import axios from 'axios'
import constants from '../../config'
import Form from '../../plugins/Form';
import Vue from 'vue'

let emptyForm = new Form({})

const state = {
  registerData: null,
  registerCurrentStep: 1,

  registerStep1Status: null,
  registerStep1Errors: emptyForm.errors,

  registerStep2Status: null,
  registerStep2Errors: emptyForm.errors,

  registerStep3Status: null,
  registerStep3Errors: emptyForm.errors,

  registerStep4Status: null,
  registerStep4Errors: emptyForm.errors,
}

// getters
const getters = {
  registerData: (state) => {
    return state.registerData
  },

  registerCurrentStep: (state) => {
    return state.registerCurrentStep
  },

  registerStepStatus: (state) => (step) => {
    return state[`registerStep${step}Status`]
  },

  registerStepErrors: (state) => (step) => {
    return state[`registerStep${step}Errors`]
  }
}

// actions
const actions = {

  fetchRegisterData ({commit}) {
    return axios.get(constants.BASE_URL + 'register/data')
     .then(function (resp) {
       commit('setRegisterData', resp.data)
     })
     .catch(function (resp) {
       console.log('Register data could not be found', resp)
     })
  },

  registerStep({commit, state}, formData) {
    let endpoint = `register/step-${formData.step}`
    let requestType = 'post'
    let withFiles = formData.withFiles != null

    if (formData.opType === 'update') {
      formData['_method'] = 'put'
    }

    let form = new Form(formData)

    return form.submit(requestType, constants.BASE_URL + endpoint, withFiles)
      .then((resp) => {
        commit('setRegisterStepStatus', {'status': 'success', 'step': formData.step})
        commit('setRegisterStepErrors', {'errors': form.errors, 'step': formData.step})
      })
      .catch((resp) => {
        commit('setRegisterStepStatus', {'status': 'failed', 'step': formData.step})

        if (form.errors.any()) {
          commit('setRegisterStepErrors', {'errors': form.errors, 'step': formData.step})
        } else {
          let internalError = {internalError: true}

          form.errors.record(internalError)
          commit('setRegisterStepErrors', {'errors': form.errors, 'step': formData.step})
        }
      })
  },

  registerCurrentStep({commit, state}, step) {
    commit('setRegisterCurrentStep', step);
  }
}


// mutations
const mutations = {
  setRegisterData (state, data) {
    state.registerData = data
  },

  setRegisterStepStatus (state, data) {
    state[`registerStep${data.step}Status`] = data.status
  },

  setRegisterStepErrors (state, data) {
    state[`registerStep${data.step}Errors`] = data.errors
  },

  setRegisterCurrentStep (state, step) {
    state.registerCurrentStep = step
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}